import { $ } from '../lib/dom.js';

const BASE = 12847;
const PER_MIN = 4.2;
const TICK_MS = 1000;

export function initSleepCounter() {
  const el = $('#sleep-counter');
  if (!el) return;
  const start = performance.now();
  function tick() {
    const elapsedMin = (performance.now() - start) / 60000;
    const v = Math.floor(BASE + elapsedMin * PER_MIN);
    el.innerHTML = v.toLocaleString() + '<span class="unit">hrs</span>';
  }
  tick();
  setInterval(tick, TICK_MS);
}
